import { useEffect, useRef } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import { useAction } from '../utils/react-redux'
import { setToken, setUserConnected, setUserNotConnected } from '../../store/userAccount/userAccount.actions'
import { setUserUIScreen } from '../../store/ui/ui.actions'
import { USER_SCREENS } from '../../store/ui/ui.constants'
import { pick } from '../../utils/object'
import debug from 'debug'
import { USER_ID_LEGACY, USER_ID_SUB } from './UserAccount.constants'
const d = debug('keycloak')

export const EXPIRATION_SECONDS = 60

export default function useKeycloakEngine() {
  const { keycloak, initialized } = useKeycloak()
  const timeoutRef = useRef()

  const execSetUserConnected = useAction(setUserConnected)
  const execSetUserNotConnected = useAction(setUserNotConnected)
  const execSetUserScreen = useAction(setUserUIScreen)
  const execSetToken = useAction(setToken)

  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated === true) {
        const token = keycloak.token
        d('keycloak.idTokenParsed', keycloak.idTokenParsed)
        const identity = pick(keycloak.idTokenParsed, ['name', 'picture', 'email', USER_ID_LEGACY, USER_ID_SUB])
        d('connected, token', token, 'idTokenParsed', keycloak.idTokenParsed)
        execSetUserConnected({ token, identity })
      } else if (keycloak.authenticated === false) {
        d('not connected')
        execSetUserNotConnected()
      }
      execSetUserScreen(USER_SCREENS.default)
    }
  }, [initialized, keycloak.authenticated])

  const updateAndSaveToken = () =>
    keycloak
      .updateToken(EXPIRATION_SECONDS)
      .then(hasTokenBeenRefreshed => {
        d('updateToken - hasTokenBeenRefreshed', hasTokenBeenRefreshed, 'new token', keycloak.token)
        execSetToken(keycloak.token)
      })
      .catch(e => {
        d('updateToken failed - disconnect user', e)
        execSetUserNotConnected()
      })

  useEffect(() => {
    const checkIfTokenWillExpire = () => {
      if (keycloak.authenticated) {
        d('checkIfTokenWillExpire')
        if (keycloak.isTokenExpired(EXPIRATION_SECONDS)) {
          d('isTokenExpired:true')
          updateAndSaveToken()
        }
        timeoutRef.current = setTimeout(checkIfTokenWillExpire, EXPIRATION_SECONDS * 1000)
      }
    }
    if (keycloak.authenticated) {
      timeoutRef.current = setTimeout(checkIfTokenWillExpire, EXPIRATION_SECONDS * 1000)
    }
    return () => {
      clearTimeout(timeoutRef)
    }
  }, [keycloak.authenticated, timeoutRef])

  useEffect(() => {
    keycloak.onTokenExpired = () => {
      d('token expired')
      updateAndSaveToken()
    }
  }, [])
}
